module.exports = __webpack_public_path__ + "img/cruise.d19a7fa4.png";